import { useNavigate } from 'react-router';

import { Accordion, Button } from '@any-ui-react/core';

import { CheckCircleIcon, SuccessIcon } from '@anyx/shared-icons';

import { SettingGuideItem } from './useSettingGuideItems';

export const SettingGuideContent = ({ items }: { items: SettingGuideItem[] }) => {
  const navigate = useNavigate();
  return (
    <div className="border-gray-1 grid grid-cols-3 border-t pb-0">
      <Accordion chevron={null} className="col-span-2 pt-2 pb-4">
        {items.map((item, key) => {
          return (
            <Accordion.Item value={`item-${key}`} key={key} className="border-0">
              <Accordion.Control
                classNames={{
                  control:
                    'w-full border-0 pr-12 pl-4 hover:bg-inherit aria-expanded:hover:text-inherit aria-[expanded=false]:hover:text-link',
                  label: 'py-2 text-sm aria-expanded:font-semibold',
                }}
              >
                <div className="flex items-center">
                  {item.isChecked ? (
                    <SuccessIcon className="h-4 w-4" />
                  ) : (
                    <CheckCircleIcon className="text-gray-2 h-4 w-4" />
                  )}
                  <p className="accordion-trigger-item-header ml-3">{item?.title}</p>
                </div>
              </Accordion.Control>
              <Accordion.Panel classNames={{ content: 'pb-1 pl-4' }}>
                <p className="text-gray-7 mt-1 ml-7 text-xs leading-4">{item?.content}</p>
                {item?.link?.pathname ? (
                  <Button
                    className="mt-3 ml-7"
                    onClick={() =>
                      navigate({
                        pathname: item?.link?.pathname || '',
                        search: item?.link?.search || '',
                      })
                    }
                    variant="default"
                  >
                    {item?.button}
                  </Button>
                ) : null}
              </Accordion.Panel>
            </Accordion.Item>
          );
        })}
      </Accordion>
      <img
        loading="lazy"
        className="col-span-1 ml-auto h-36"
        src="/assets/common-onboarding/setting-guide.png"
        alt="setting guide"
      />
    </div>
  );
};
